import { requestAPI } from '@api/base'

export async function createSubmissionAPI(formId: string, encryptedChunks: string[]) {
  return await requestAPI(`forms/${formId}/submissions`, 'POST', { submission: { encrypted_chunks: encryptedChunks }})
}

export async function getSubmissionAPI(formId: string, submissionId: string) {
  return await requestAPI(`forms/${formId}/submissions/${submissionId}`)
}
